import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Download de Arquivo" />;
}

export default GridHeader;